
export type ReplacementHistoryRow = {
    id: string | number
    meterId: string | number
    fromDate: string | Date
    toDate?: string | Date
    replaceReason?: string
    imagesCount?: number
    reportCount?: number
    reportUrl?: string
    reason?: string
    photosCount?: number
    reportsCount?: number
  }
  
  export function getGenericMockHistory(): ReplacementHistoryRow[] {
    return []
  }
  